// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
     
    $(document).ready(function () {

        if ($('.blinds-configurator').length > 0) {
            ; (function () {
                var Configure = {
                    dom: {
                        base: $('.blinds-configurator'),
                        section: $('.blinds-configurator').closest('section'),
                        lastSection: $('.configure-block').last()
                    },
                    set: {
                        offset: null,
                        height: null,
                        section: {
                            top: null,
                            bottom: null
                        },
                        marginTop: null,
                        scroll: null,
                        activeClass: 'fixed',
                        stopClass: 'stop'
                    },
                    fn: {
                        initiate: function () {
                            $set.offset = $dom.base.offset();
                            $set.section.top = $dom.section.offset().top;
                            $set.section.bottom = $dom.lastSection.offset().top + $dom.lastSection.outerHeight();
                            $set.marginTop = $set.offset.top - $set.section.top;
                        },
                        scroll: function () {
                            $set.scroll = $(window).scrollTop();

                            $set.height = $dom.base.outerHeight();
                            $set.section.bottom = $dom.lastSection.outerHeight() + $dom.lastSection.offset().top - $set.marginTop - $set.height;

                            if ($set.scroll < $set.section.top) {
                                $dom.base.removeClass($set.activeClass + ' ' + $set.stopClass).removeAttr('style');
                            } else if ($set.scroll > $set.section.top && $set.scroll < $set.section.bottom) {
                                $dom.base.removeClass($set.stopClass).addClass($set.activeClass).css({ top: $set.marginTop });
                            }
                        }
                    }
                },
                /* Add quick access variables to be used in local function
                * Keep main variable name in case it needs to be shared with other JS files
                */
                $dom = Configure.dom,
                $set = Configure.set,
                $fn = Configure.fn;

                /* Set a small timeout to make sure the fonts are rendered */
                setTimeout(function () {
                    $fn.initiate();
                    $(window).on({
                        scroll: $fn.scroll
                    });
                }, 100);

            });
        }

    });

})(window, document, jQuery);